import { writable, derived } from 'svelte/store';
export const AUTHENTICATION = writable({});
export const SESSION = writable(null);
export const SESSION_USER = derived(SESSION, $SESSION => {
    if ($SESSION !== null) {
        return $SESSION.user;
    }
    return null;
});
export const SESSION_ORGANIZATION = derived(SESSION, $SESSION => {
    if ($SESSION !== null) {
        return $SESSION.organization;
    }
    return null;
});
export const USER_KEY = derived(SESSION, $SESSION => {
    if ($SESSION !== null) {
        return $SESSION.user._.key;
    }
    return null;
});
export const ORGANIZATION_KEY = derived(SESSION, $SESSION => {
    if ($SESSION !== null) {
        return $SESSION.organization._.key;
    }
    return null;
});
export const DOMAIN = derived(SESSION, $SESSION => {
    if ($SESSION !== null) {
        return $SESSION.organization.domain;
    }
    return null;
});
export const IS_ORGANIZATION_APPROVED = derived(SESSION_ORGANIZATION, $SESSION_ORGANIZATION => $SESSION_ORGANIZATION?._.state === 'approved');
